import TopDevelopers from "../../components/public/userCommon/TopDevelopers";
import BuySellBanner from "../../components/public/userHome/BuySellBanner";
import CommercialPropertySection from "../../components/public/userHome/CommercialPropertySection";
import ExploreLocations from "../../components/public/userHome/ExploreLocations";
import FeaturedProjects from "../../components/public/userHome/FeaturedProjects";
import FeatureHighlights from "../../components/public/userHome/FeatureHighlights";
import HeroSlider from "../../components/public/userHome/HeroSlider";
import HomeTestimonials from "../../components/public/userHome/HomeTestimonials";
import LogoCarousel from "../../components/public/userHome/LogoCarousel";
import MarketInsights from "../../components/public/userHome/MarketInshights";
import OurService from "../../components/public/userHome/OurService";
import PreferredAgents from "../../components/public/userHome/PreferredAgents";
import PropertyCategories from "../../components/public/userHome/PropertyCategories";
import RecommendedPropertySection from "../../components/public/userHome/RecommendedPropertySection";
import TopArticles from "../../components/public/userHome/TopArticles";

const Home = () => {
  return (
    <div className="overflow-hidden">
      <HeroSlider />
      <FeatureHighlights />
      <PropertyCategories />
      <RecommendedPropertySection />
      <CommercialPropertySection />
      <FeaturedProjects />
      <LogoCarousel />
      <ExploreLocations />
      <OurService />
      <PreferredAgents />
      <BuySellBanner />
      <div className="px-4 sm:px-6 md:px-8 lg:px-10 py-6 md:py-8 lg:py-10 bg-white">
        <TopDevelopers title="Top Developers in Bhubaneswar" />
      </div>
      <TopArticles />
      <MarketInsights />
      <HomeTestimonials />
    </div>
  );
};

export default Home;
